import React, { useState, useEffect } from 'react';
import { Modal, Button, Form } from 'react-bootstrap'; // Usando react-bootstrap como exemplo
import Swal from 'sweetalert2';
import { useAuth } from '../../Context/auth'; // Ajuste o caminho

// Hook genérico de API (copiado de EditarProducao)
const useApiCall = () => {
    const { currentUser } = useAuth();
    
    return React.useCallback(async (url, method = 'GET', data = null) => {
        if (!currentUser) throw new Error("Usuário não autenticado.");
        const token = await currentUser.getIdToken();
        const API_URL = process.env.REACT_APP_API_URL;
        const config = { method, headers: { 'Authorization': `Bearer ${token}` }};
        if (data && method !== 'GET' && method !== 'HEAD') {
            config.headers['Content-Type'] = 'application/json';
            config.body = JSON.stringify(data);
        }
        const response = await fetch(`${API_URL}${url}`, config);
        if (!response.ok) {
            const errorData = await response.json().catch(() => ({}));
            console.error(`Falha na API (${response.status}): ${method} ${url}`, errorData);
            throw new Error(errorData.error || `Falha na requisição (${response.status})`);
        }
        if (response.status === 204) return null;
        return response.json();
    }, [currentUser]);
};

// Formato de data YYYY-MM-DD
const getISODate = (date = new Date()) => date.toISOString().split('T')[0];

function ModalBaixarInsumo({ isVisible, onClose, insumo, onBaixaSucesso }) {
    const apiCall = useApiCall();
    const [dataBaixa, setDataBaixa] = useState(getISODate());
    const [quantidade, setQuantidade] = useState(0);
    const [loading, setLoading] = useState(false);

    const qtdNecessaria = parseFloat(insumo.quantidade_total_necessaria) || 0;
    const qtdBaixada = parseFloat(insumo.quantidade_baixada) || 0;
    const qtdABaixar = Math.max(0, qtdNecessaria - qtdBaixada);

    useEffect(() => {
        if (isVisible) {
            // Define a quantidade padrão ao abrir o modal
            setQuantidade(qtdABaixar.toFixed(4));
            setDataBaixa(getISODate());
        }
    }, [isVisible, qtdABaixar]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        const qtd = parseFloat(quantidade);

        if (qtd <= 0) {
            Swal.fire("Erro", "A quantidade deve ser maior que zero.", "error");
            setLoading(false);
            return;
        }
        if (qtd > (qtdABaixar + 0.0001)) { // Tolerância
             Swal.fire("Erro", `Quantidade excede o saldo a baixar (${qtdABaixar.toFixed(4)}).`, "error");
            setLoading(false);
            return;
        }

        try {
            await apiCall('/api/producao/insumo/baixar', 'POST', {
                producaoInsumoId: insumo.id,
                dataMovimentacao: dataBaixa,
                quantidade: qtd
            });
            Swal.fire("Sucesso!", "Baixa de insumo registrada.", "success");
            onBaixaSucesso(); // Recarrega os dados na tela principal
        } catch (error) {
            console.error("Erro ao baixar insumo:", error);
            Swal.fire("Erro!", error.message || "Não foi possível registrar a baixa.", "error");
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal show={isVisible} onHide={onClose} centered>
            <Modal.Header closeButton>
                <Modal.Title>Baixar Insumo</Modal.Title>
            </Modal.Header>
            <Form onSubmit={handleSubmit}>
                <Modal.Body>
                    <div className="mb-3">
                        <label className="form-label">Insumo</label>
                        <input
                            type="text"
                            className="form-control"
                            readOnly
                            disabled
                            // === AJUSTE AQUI para incluir a cor ===
                            value={`${insumo.insumo_codigo} - ${insumo.insumo_descricao}${insumo.cor ? ` - ${insumo.cor}` : ''}`}
                        />
                    </div>
                    <div className="mb-3">
                         <label className="form-label">Saldo a Baixar</label>
                        <input
                            type="text"
                            className="form-control"
                            readOnly
                            disabled
                            value={`${qtdABaixar.toFixed(4)} ${insumo.insumo_unidade_medida || ''}`}
                        />
                    </div>
                    <Form.Group className="mb-3" controlId="formDataBaixa">
                        <Form.Label>Data da Baixa</Form.Label>
                        <Form.Control
                            type="date"
                            value={dataBaixa}
                            onChange={(e) => setDataBaixa(e.target.value)}
                            required
                        />
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="formQuantidade">
                        <Form.Label>Quantidade a Baixar</Form.Label>
                        <Form.Control
                            type="number"
                            step="0.0001"
                            min="0.0001"
                            max={qtdABaixar.toFixed(4)}
                            value={quantidade}
                            onChange={(e) => setQuantidade(e.target.value)}
                            required
                            autoFocus
                        />
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={onClose} disabled={loading}>
                        Cancelar
                    </Button>
                    <Button variant="primary" type="submit" disabled={loading}>
                        {loading ? <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span> : null}
                        Confirmar Baixa
                    </Button>
                </Modal.Footer>
            </Form>
        </Modal>
    );
}

export default ModalBaixarInsumo;